import React from 'react';
import styled from 'styled-components';
import { ProjectContainer, ProjectTitle, ProjectInfo } from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;
  
  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }
  
  p {
    line-height: 24px;
    margin-bottom: 15px;
  }
  
  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
  }
  
  .seeDemo {
    text-align: center;
    margin: 20px 0;
    
    a {
      background: #F34452;
      color: #FFF;
      padding: 12px 30px;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 3px;
      transition: all 0.3s;
      display: inline-block;
      
      &:hover {
        background: #d63946;
      }
    }
  }
  
  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    
    li {
      b {
        color: #333;
      }
    }
  }
  
  .closeBtn {
    text-align: center;
    margin-top: 30px;
    
    button {
      background: #007bff;
      color: #FFF;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;
      
      &:hover {
        background: #0056b3;
      }
      
      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectNonprofitProps {
}

const ProjectNonprofit: React.FC<ProjectNonprofitProps> = () => {
  const { t } = useLanguage();
  
  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t('nonprofit.title')}</h2>
        <p className="tags">{t('nonprofit.role')}</p>
      </ProjectTitle>
      
      <ProjectDescription>
        {t('nonprofit.description')}
      </ProjectDescription>
      
      <ProjectInfo>
        <p><b>{t('nonprofit.roleLabel')}</b> {t('nonprofit.myRole')}</p>
        <p><b>{t('nonprofit.skillsLabel')}</b> {t('nonprofit.skillsUtilized')}</p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t('nonprofit.targetProblems')}</h4>
        <p>{t('nonprofit.problemDescription')}</p>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('nonprofit.ourSolutions')}</h4>
        <p>{t('nonprofit.solutionDescription')}</p>
        <div className="seeDemo">
          <a href="http://probonobos.github.io/rhok/" target="_blank" rel="noopener noreferrer">{t('nonprofit.seeDemo')}</a>
        </div>
        <img loading="lazy" decoding="async" src="/images/projects/solution-min.webp" className="img-responsive" alt="probonobos"/>
        <img loading="lazy" decoding="async" src="/images/portfolio/p9-nonprofit-min.webp" className="img-responsive" alt="probonobos"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li><b>{t('nonprofit.dateLabel')}</b> {t('nonprofit.date')}</li>
          <li><b>{t('nonprofit.clientLabel')}</b> {t('nonprofit.client')}</li>
          <li><b>{t('nonprofit.teamMembersLabel')}</b> {t('nonprofit.teamMembers')}</li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectNonprofit;